export default "__VITE_ASSET__ym3k4$p$__"